import AuthModalManager from '../views/auth/AuthModalManager';

const Common = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      {children}
      <AuthModalManager />
    </div>
  );
};

export default Common;
